<template>
<div>
    <v-container class="px-0">
        <v-col cols="12">
            <v-row>
                <v-col cols="12" lg="12" md="12">
                    
                    <high-charts-drill-bar
                        :id="1000" 
                        :items="items"
                        :visibleTitle="true"
                        :title="'GESTION POR DIA'"
                        :number="true"
                        :name="'Dìa'"
                        :typeGraph="'line'"
                        :legend="true"
                    />
                    
                </v-col>
            </v-row>
        </v-col>
    </v-container>
</div>
</template>

<script>
import HighChartsDrillBar from '@/components/Utils/HighCharts/HighChartsDrillBar.vue';

export default {
    props: {
        items: {
            type: Array,
            default: []
        },
       
    },
    components: {
        
        HighChartsDrillBar
    },
    data() {
        return {

        };
    },
    methods: {},
};
</script>

<style>
.tran {
    opacity: 0.7 !important;
}
</style>
